module.exports = {"341022100":"海阳镇","341022101":"齐云山镇","341022102":"万安镇","341022103":"五城镇","341022104":"东临溪镇","341022105":"蓝田镇","341022106":"溪口镇","341022107":"流口镇","341022108":"汪村镇","341022109":"商山镇","341022201":"山斗乡","341022202":"岭南乡","341022203":"渭桥乡","341022204":"板桥乡","341022205":"陈霞乡","341022206":"鹤城乡","341022207":"源芳乡","341022208":"榆村乡","341022209":"龙田乡","341022210":"璜尖乡","341022211":"白际乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341022.json
// module id = 1018
// module chunks = 0